module.exports = __webpack_public_path__ + "static/img/exhibitFormTips5.9e5ba97e.png";